<li
  (click)="isCheckable ? _onClick(checkContentInput.nativeElement) : _onClick()"
  class="list-el-container mb-3 col-12 disable-li-style position-relative"
  [class.disabled]="disabled"
>
  <app-card
    [cursorPointer]="cursorPointer"
    [enableHover]="enableHover"
    borderRadius="10px"
    height="100%"
    padding="24px 28px"
    [backgroundColor]="
      disabled ? '#d9d9d9' : backgroundColor ? backgroundColor : '#fff'
    "
    [ngClass]="{
      'enabled-card': customTemplate === 'CONTENTS' && entityData?.enabled,
      'disabled-card': customTemplate === 'CONTENTS' && !entityData?.enabled,
      'class-card': customTemplate === 'CLASSES',
      'completed-class': (customTemplate === 'CLASSES' && entityData?.average_progress === 100) || (customTemplate === 'USERS' && entityData.progress?.progress_percentage === 100),
      'wellness-warning': (customTemplate === 'USERS' && wellnessWarningActive),
    }"
  >
    <article card__content>
      <ng-container
        *ngIf="customTemplate === 'DEFAULT'"
        [ngTemplateOutlet]="defaultTemplate"
        [ngTemplateOutletContext]="{ $implicit: entityData }"
      >
      </ng-container>
      <ng-container
        *ngIf="customTemplate === 'CLASSES'"
        [ngTemplateOutlet]="defaultTemplateClasses"
        [ngTemplateOutletContext]="{ $implicit: entityData }"
      >
      </ng-container>
      <ng-container
        *ngIf="customTemplate === 'TEAMS'"
        [ngTemplateOutlet]="defaultTemplateTeams"
        [ngTemplateOutletContext]="{ $implicit: entityData }"
      >
      </ng-container>
      <ng-container
        *ngIf="customTemplate === 'USERS'"
        [ngTemplateOutlet]="defaultTemplateUsers"
        [ngTemplateOutletContext]="{ $implicit: entityData }"
      >
      </ng-container>
      <ng-container
        *ngIf="customTemplate === 'CONTENTS'"
        [ngTemplateOutlet]="defaultTemplateContents"
        [ngTemplateOutletContext]="{ $implicit: entityData }"
      >
      </ng-container>
      <ng-container
        *ngIf="customTemplate === 'ORGANIZATIONS'"
        [ngTemplateOutlet]="defaultTemplateOrganizations"
        [ngTemplateOutletContext]="{ $implicit: entityData }"
      >
      </ng-container>
    </article>
  </app-card>
</li>

<ng-template #defaultTemplate>
  <div
    class="row gap-2 gap-lg-0 ps-3 ps-lg-0"
    [class.ps-lg-3]="isCheckable || isDragable"
  >
    <div
      class="d-flex align-items-md-center justify-content-start col-12 col-xxl-1 m-0 p-0 text-italic"
      [class.col-lg-1]="!isDragable && !isCheckable"
      [class.col-lg-2]="isDragable && isCheckable"
      [class.justify-content-center]="!isDragable && !isCheckable"
    >
      <section
        class="d-flex flex-nowrap row-md w-100 gap-2"
        [class.gap-4]="isDragable && isCheckable"
      >
        <div
          *ngIf="isDragable"
          cdkDragHandle
          class="col-1 d-flex"
          [class.justify-content-center]="isDragable && isCheckable"
        >
          <img
            src="/assets/images/icons/icon_drag.svg"
            alt="Drag icon to order each element"
          />
        </div>
        <div
          *ngIf="isCheckable"
          class="col-1 d-flex"
          [class.justify-content-center]="isDragable && isCheckable"
        >
          <input
            #checkContentInput
            type="checkbox"
            [checked]="disabled"
            [disabled]="disabled"
            (change)="_onClick(checkContentInput)"
            style="pointer-events: none"
            class="d-none"
          />
          <img
            *ngIf="checkContentInput.checked"
            [src]="
              disabled
                ? '/assets/images/icons/icon_checked_disabled.svg'
                : '/assets/images/icons/icon_checked.svg'
            "
            alt="check input icon"
            class="w-24px h-24px"
          />
          <img
            *ngIf="!checkContentInput.checked"
            src="/assets/images/icons/icon_unchecked.svg"
            alt="check input icon"
            class="w-24px h-24px"
          />
        </div>
        <div
          class="d-flex"
          [class.col-12]="!isDragable && !isCheckable"
          [class.col-10]="isDragable || isCheckable"
          [class.justify-content-lg-center]="!isDragable || !isCheckable"
        >
          <strong
            ><i class="text-black-50" style="opacity: 0.8"
              ><small>ID{{ entityData["id"] }}</small></i
            ></strong
          >
        </div>
      </section>
    </div>

    <div
      class="d-flex flex-column justify-content-center gap-2 gap-md-0 col-12 col-lg-9 col-xl-8"
    >
      <div class="row w-100 w-md-32">
        <span class="font-bold fs-5 m-0 p-0">{{
          entityData["name"] | trimString
        }}</span>
      </div>
      <div *ngIf="!isSingleRowDesign" class="row">
        <div class="d-flex align-items-center p-0 m-0 col-12 col-lg-8">
          <div>
            <span *ngIf="entityData['is_published']">
              <small class="text-green responsive-text">
                {{ "shared-components.list-element.published" | translate }}
              </small>
            </span>
            <span *ngIf="!entityData['is_published']">
              <small class="responsive-text">
                {{ "shared-components.list-element.not-published" | translate }}
              </small>
            </span>
          </div>
          <div
            class="d-flex align-items-center justify-content-center p-0 m-0 mx-2"
          >
            <div class="h-20px border border-1 border-dark"></div>
          </div>
          <div class="d-flex align-items-center justify-content-center p-0 m-0">
            <span
              ><small
                class="responsive-text"
                [innerHTML]="
                  ('shared-components.list-element.description' | translate) +
                  (entityData['description']
                    ? (entityData['description'] | trimString : 80)
                    : 'N/A')
                "
              ></small
            ></span>
          </div>
        </div>
      </div>
      <div *ngIf="!isSingleRowDesign" class="row mt-1">
        <!-- <div
          *ngIf="[].length === 0"
          class="d-flex align-items-center p-0 m-0 h-20px"
        >
          <hr class="m-0 w-100" />
        </div> -->
        <ul
          *ngIf="[].length === 0"
          class="d-flex align-items-center gap-2 flex-wrap p-0 m-0"
        >
          <li
            *ngFor="
              let element of [
                '2do ESO',
                'Vocacion',
                'Valores',
                'Vocacion',
                'Valores',
                '2do Eso'
              ]
            "
            class="list-el-tag"
            [class.list-el-tag--orange-alt]="tagsTemplate === 'yellowTemplate'"
          >
            <section class="d-flex gap-2">
              <img
                *ngIf="tagsTemplate === 'default'"
                src="/assets/images/icons/icon_list_tag.svg"
                alt="tag icon"
              />
              <img
                *ngIf="tagsTemplate === 'yellowTemplate'"
                src="/assets/images/icons/icon_selector.svg"
                alt="tag icon"
              />
              <span>{{ element }}</span>
            </section>
            <img
              *ngIf="tagsTemplate === 'yellowTemplate'"
              src="/assets/images/icons/close_white_icon.svg"
              class="h-11px"
            />
          </li>
        </ul>
      </div>
    </div>

    <div
      class="d-flex flex-column align-items-lg-center justify-content-center col-12 col-lg-2 col-xl-3 mt-3 m-md-0 p-0"
    >
      <div
        class="d-flex align-items-center justify-content-lg-end gap-3 buttons-container"
      >
        <button
          *ngFor="let action of actions"
          class="cursor-pointer border-0 bg-transparent"
          (click)="_onClickAction($event, action.action)"
        >
          <img
            class="h-28px"
            [src]="action.icon"
            [alt]="action.action + 'icon'"
          />
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultTemplateClasses>
  <div
    class="notification-container"
    *ngIf="entityData['waiting_requests_count']"
    (click)="_onClickAction($event, 'petitions')"
  >
    <p>{{ formatNumber(entityData["waiting_requests_count"]) }}</p>
  </div>
  <div
    class="row gap-2 gap-lg-0 ps-3 ps-lg-0"
    [class.ps-lg-3]="isCheckable || isDragable"
  >
<!--    <div-->
<!--      class="d-flex align-items-md-start justify-content-start col-12 col-xxl-1 m-0 p-0 text-italic"-->
<!--      [class.col-lg-1]="!isDragable && !isCheckable"-->
<!--      [class.col-lg-2]="isDragable && isCheckable"-->
<!--      [class.justify-content-center]="!isDragable && !isCheckable"-->
<!--    >-->
<!--      <section-->
<!--        class="d-flex flex-nowrap row-md w-100 gap-2"-->
<!--        [class.gap-4]="isDragable && isCheckable"-->
<!--      >-->
<!--        <div-->
<!--          *ngIf="isDragable"-->
<!--          cdkDragHandle-->
<!--          class="col-1 d-flex"-->
<!--          [class.justify-content-center]="isDragable && isCheckable"-->
<!--        >-->
<!--          <img-->
<!--            src="/assets/images/icons/icon_drag.svg"-->
<!--            alt="Drag icon to order each element"-->
<!--          />-->
<!--        </div>-->
<!--        <div-->
<!--          *ngIf="isCheckable"-->
<!--          class="col-1 d-flex"-->
<!--          [class.justify-content-center]="isDragable && isCheckable"-->
<!--        >-->
<!--          <input-->
<!--            #checkContentInput-->
<!--            type="checkbox"-->
<!--            [checked]="disabled"-->
<!--            [disabled]="disabled"-->
<!--            (change)="_onClick(checkContentInput)"-->
<!--            style="pointer-events: none"-->
<!--            class="d-none"-->
<!--          />-->
<!--          <img-->
<!--            *ngIf="checkContentInput.checked"-->
<!--            [src]="-->
<!--              disabled-->
<!--                ? '/assets/images/icons/icon_checked_disabled.svg'-->
<!--                : '/assets/images/icons/icon_checked.svg'-->
<!--            "-->
<!--            alt="check input icon"-->
<!--            class="w-24px h-24px"-->
<!--          />-->
<!--          <img-->
<!--            *ngIf="!checkContentInput.checked"-->
<!--            src="/assets/images/icons/icon_unchecked.svg"-->
<!--            alt="check input icon"-->
<!--            class="w-24px h-24px"-->
<!--          />-->
<!--        </div>-->
<!--      </section>-->
<!--    </div>-->

    <div
      class="d-flex flex-column justify-content-center gap-2 gap-md-0 col-12 col-lg-9 col-xl-8"
    >
      <div class="row w-100 w-md-32">
        <span class="font-bold fs-5 m-0 p-0 ps-2">{{
          entityData["name"] | trimString
        }}</span>
      </div>
      <div *ngIf="!isSingleRowDesign" class="row">
        <div class="d-flex align-items-center p-0 ps-2 m-0 col-12 col-lg-8">
          <div class="d-flex align-items-center justify-content-center p-0 m-0">
            <span>
              <small
                class="responsive-text"
                [innerHTML]="
                   (entityData['description'] | trimString : 80)
                "
              >
              </small>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="!isSingleRowDesign" class="row mt-1">
        <span class="m-0 p-0 ps-2 class-teacher">
          <small class="responsive-text">
            <svg class="stat-icon" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"></path>
            </svg>
            {{
              entityData["teacher"]
                ? entityData["teacher"].first_name +
                  entityData["teacher"].last_name
                : "N/A"
            }}
          </small>
        </span>
      </div>
    </div>

    <div
      class="d-flex flex-column align-items-lg-center justify-content-center col-12 col-lg-2 col-xl-3 mt-3 m-md-0 p-0"
    >
      <div class="class-actions">
        <button
          *ngFor="let action of actions"
          class="action-btn"
          [ngClass]="{
            'btn-edit': action.action === 'edit',
            'btn-delete': action.action === 'delete',
          }"
          (click)="_onClickAction($event, action.action)"
        >
          <!-- Icono de Editar -->
          <svg *ngIf="action.action === 'edit'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
          </svg>
          <!-- Icono de Eliminar -->
          <svg *ngIf="action.action === 'delete'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
          </svg>
          <!-- Icono de Más -->
          <svg *ngIf="action.action === 'more'" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="class-stats">
    <span class="stat-badge students">
        <svg class="stat-icon" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"></path>
        </svg>
      {{ entityData["student_count"] }}
      {{ "shared-components.list-element.students" | translate }}
    </span>
    <span class="stat-badge progress" [ngClass]="{'high' : entityData['average_progress'] === 100}">
        <svg class="stat-icon" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"></path>
        </svg>
      {{ entityData["average_progress"] | customPercentage }}
      {{ "shared-components.list-element.average-progress" | translate }}
    </span>
    <span class="stat-badge chapters">
      <svg class="stat-icon" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"></path>
      </svg>
      {{ entityData["average_chapters_completed"] || 0 }}/{{ entityData["average_chapters_total"] || 0 }}
      ({{ entityData["average_chapters_total"] && entityData["average_chapters_total"] > 0 ? ((entityData["average_chapters_completed"] / entityData["average_chapters_total"] * 100) | number:'1.0-0') : 0 }}%)
      {{ "shared-components.list-element.average-chapters-completed" | translate }}
    </span>
  </div>
</ng-template>

<ng-template #defaultTemplateTeams let-groupData>
  <div
    class="row gap-2 gap-lg-0 ps-3 ps-lg-0"
    [class.ps-lg-3]="isCheckable || isDragable"
  >
    <div
      class="d-flex align-items-md-center justify-content-start col-12 col-xxl-1 m-0 p-0 text-italic"
      [class.col-lg-1]="!isDragable && !isCheckable"
      [class.col-lg-2]="isDragable && isCheckable"
      [class.justify-content-center]="!isDragable && !isCheckable"
    >
      <section
        class="d-flex flex-nowrap row-md w-100 gap-2"
        [class.gap-4]="isDragable && isCheckable"
      >
        <div
          *ngIf="isDragable"
          cdkDragHandle
          class="col-1 d-flex"
          [class.justify-content-center]="isDragable && isCheckable"
        >
          <img
            src="/assets/images/icons/icon_drag.svg"
            alt="Drag icon to order each element"
          />
        </div>
        <div
          class="d-flex"
          [class.col-12]="!isDragable && !isCheckable"
          [class.col-10]="isDragable || isCheckable"
          [class.justify-content-lg-center]="!isDragable || !isCheckable"
        >
          <img
            src="/assets/images/icons/icon_team_green.svg"
            alt="Team avatar"
          />
        </div>
      </section>
    </div>

    <div
      class="d-flex flex-column justify-content-center gap-2 gap-md-0 col-12 col-lg-9 col-xl-8"
    >
      <div class="row w-100 w-md-32">
        <span class="font-bold fs-5 m-0 p-0">{{
          groupData["name"] | trimString
        }}</span>
      </div>
      <div *ngIf="!isSingleRowDesign" class="row">
        <div class="d-flex align-items-center p-0 m-0 col-12 col-lg-8">
          <div>
            <span>
              <small class="text-green responsive-text">
                {{ groupData["users"] ?? 10 }}
                {{ "shared-components.list-element.users" | translate }}
              </small>
            </span>
          </div>
          <div
            class="d-flex align-items-center justify-content-center p-0 m-0 mx-2"
          >
            <div class="h-20px border border-1 border-dark"></div>
          </div>
          <div class="d-flex align-items-center justify-content-center p-0 m-0">
            <span
              ><small
                class="responsive-text"
                [innerHTML]="
                  groupData['description']
                    ? (groupData['description'] | trimString : 80)
                    : 'N/A'
                "
              ></small
            ></span>
          </div>
        </div>
      </div>
      <div *ngIf="!isSingleRowDesign" class="row mt-1">
        <ul
          *ngIf="[].length === 0"
          class="d-flex align-items-center gap-2 flex-wrap p-0 m-0"
        >
          <li
            *ngFor="
              let element of [
                '2do ESO',
                'Vocacion',
                'Valores',
                'Vocacion',
                'Valores',
                '2do Eso'
              ]
            "
            class="list-el-tag"
            [class.list-el-tag--orange-alt]="tagsTemplate === 'yellowTemplate'"
          >
            <section class="d-flex gap-2">
              <img
                *ngIf="tagsTemplate === 'default'"
                src="/assets/images/icons/icon_list_tag.svg"
                alt="tag icon"
              />
              <img
                *ngIf="tagsTemplate === 'yellowTemplate'"
                src="/assets/images/icons/icon_selector.svg"
                alt="tag icon"
              />
              <span>{{ element }}</span>
            </section>
            <img
              *ngIf="tagsTemplate === 'yellowTemplate'"
              src="/assets/images/icons/close_white_icon.svg"
              class="h-11px"
            />
          </li>
        </ul>
      </div>
    </div>

    <div
      class="d-flex flex-column align-items-lg-center justify-content-center col-12 col-lg-2 col-xl-3 mt-3 m-md-0 p-0"
    >
      <div
        class="d-flex align-items-center justify-content-lg-end gap-3 buttons-container"
      >
        <button
          *ngFor="let action of actions"
          class="cursor-pointer border-0 bg-transparent"
          (click)="_onClickAction($event, action.action)"
        >
          <img
            class="h-28px"
            [src]="action.icon"
            [alt]="action.action + 'icon'"
          />
        </button>
      </div>
    </div>

    <section class="colors">
      <div
        [style.background]="
          'linear-gradient(-250deg, rgba(217, 217, 217, 0) 19.19%, ' +
          groupData.background_color +
          ' 53.96%, ' +
          groupData.gradient_color +
          ' 84.87%)'
        "
      ></div>
    </section>
  </div>
</ng-template>

<ng-template #defaultTemplateUsers let-userData>
  <div class="row gap-2 gap-lg-0 ps-3 ps-lg-0">
    <div
      class="d-flex align-items-md-center justify-content-center col-12 col-lg-1 col-xxl-1 m-0 p-0 text-italic"
    >
      <section class="d-flex flex-nowrap row-md w-100">
        <div
          class="d-flex justify-content-lg-center align-items-center pt-3 gap-2"
          [class.col-12]="!isCheckable"
          [class.col-10]="isCheckable"
        >
          <div
            *ngIf="selectable"
            class="gr-checkbox"
            [class.gr-checkbox--checked]="selected && !selectableDisabled"
            [class.gr-checkbox--disabled]="selectableDisabled"
            [ngbTooltip]="selectableDisabled && selectableTooltip ? selectableTooltip : null"
            (click)="_onSelectionClick($event)"
            role="checkbox"
            [attr.aria-checked]="selected"
            [attr.aria-disabled]="selectableDisabled"
            tabindex="0"
          >
            <svg
              *ngIf="selected && !selectableDisabled"
              class="gr-checkbox__icon"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 8.2 6.6 11.3 12.5 5.4"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div *ngIf="isCheckable" class="d-flex justify-content-center pb-1">
            <input
              #checkContentInput
              type="checkbox"
              [checked]="disabled"
              [disabled]="disabled"
              (change)="_onClick(checkContentInput)"
              style="pointer-events: none"
              class="d-none"
            />

            <img
              *ngIf="checkContentInput.checked"
              [src]="
                disabled
                  ? '../../../../assets/images/icons/icon_checked_disabled.svg'
                  : '../../../../assets/images/icons/icon_checked.svg'
              "
              alt="check input icon"
              class="check-input-dimensions"
            />
            <img
              *ngIf="!checkContentInput.checked"
              src="../../../../assets/images/icons/icon_unchecked.svg"
              alt="check input icon"
              class="check-input-dimensions"
            />
          </div>
          <div *ngIf="!isCheckable" class="user-initials-avatar">
            {{ ((userData.first_name?.[0] || '') + (userData.last_name?.[0] || '')) | uppercase }}
          </div>
        </div>
      </section>
    </div>

    <div
      class="d-flex flex-column justify-content-center gap-2 gap-md-0 col-12 col-lg-8 col-xl-8 ps-4"
    >
      <div class="row w-100 w-md-32">
        <span
          (click)="_onClickAction($event, 'show_user_detail')"
          class="d-flex align-items-center font-bold fs-5 m-0 p-0"
          >{{ userData.first_name + " " + userData.last_name | trimString }}
        </span>
      </div>
      <div class="row">
        <div class="d-flex align-items-center p-0 m-0 col-12 col-lg-8">
          <div class="d-flex align-items-center justify-content-center p-0 m-0">
            <span
              ><small
                ><i
                  class="responsive-text"
                  [innerHTML]="
                    userData.email ? (userData.email | trimString : 80) : 'N/A'
                  "
                ></i></small
            ></span>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <p class="text-secondary ms-0 ps-0">
          <small>ID {{ userData.id }}</small>
        </p>
      </div>
    </div>
    <div
      class="d-flex flex-column align-items-lg-center justify-content-center col-12 col-lg-1 col-xl-2 mt-3 m-md-0 p-0"
    >
      <div class="class-actions">
        <ng-container *ngFor="let action of actions">
        <button
          *ngIf="action.action !== 'wellness_notification' || wellnessWarningActive"
          class="action-btn"
          [ngClass]="{
            'btn-delete': action.action === 'delete',
            'btn-comment': action.action === 'comment',
            'btn-download': action.action === 'download_report',
            'btn-wellness': action.action === 'wellness_notification',
            'btn-regenerate': action.action === 'regenerate_report',
            'btn-regenerate-full': action.action === 'regenerate_report_full',
          }"
          (click)="_onClickAction($event, action.action)"
          [disabled]="!action.enabled"
          [ngbTooltip]="action.enabled === false ? action.tooltip : null"
        >
          <!-- Icono de Wellness Notification -->
          <svg *ngIf="action.action === 'wellness_notification'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"></path>
          </svg>
          <!-- Icono de Eliminar -->
          <svg *ngIf="action.action === 'delete'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
          </svg>
          <!-- Icono de Agregar Comentario -->
          <svg *ngIf="action.action === 'comment'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"></path>
          </svg>
          <!-- Icono de Descargar Reporte -->
          <svg *ngIf="action.action === 'download_report'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
          <!-- Icono de Regenerar Reporte -->
          <svg *ngIf="action.action === 'regenerate_report'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
          </svg>
          <!-- Icono de Regenerar Reporte Completo -->
          <svg *ngIf="action.action === 'regenerate_report_full'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l2 2"></path>
          </svg>
        </button>
        </ng-container>
      </div>
    </div>
    <div class="class-stats">
      <span class="stat-badge progress" [ngClass]="{'high' : userData.progress?.progress_percentage === 100}">
        <svg class="stat-icon" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"></path>
        </svg>
        {{ (userData.progress?.progress_percentage ?? userData.progress ?? 0) | customPercentage }}
        {{ "shared-components.list-element.progress" | translate }}
      </span>
      <span class="stat-badge chapters">
      <svg class="stat-icon" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"></path>
      </svg>
        {{ userData.progress?.children_completed_1 ?? 0 }} / {{ userData.progress?.children_total_1 ?? 0 }}
        ({{ getChaptersPercentage(userData.progress?.children_completed_1 ?? 0, userData.progress?.children_total_1 ?? 0) }}%)
        {{ "shared-components.list-element.chapters-completed" | translate }}
      </span>
      <span *ngIf="userData.last_login" class="stat-badge last-login"
        [attr.data-tooltip]="'student-detail.last-login' | translate">
        <svg class="stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        {{ userData.last_login_label }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #defaultTemplateContents let-userData>
  <div class="row gap-2 gap-lg-0 ps-3 ps-lg-0">
    <div
      class="d-flex align-items-md-center justify-content-start col-12 col-xxl-1 m-0 p-0 text-italic"
      [ngClass]="{ 'opacity-50': !userData.enabled }"
    >
      <section class="d-flex flex-nowrap row-md w-100 gap-2">
        <div class="d-flex col-12 justify-content-lg-center">
          <strong>
            <i style="opacity: 0.8">
              <small class="text-link text-gray"> ID {{ userData.id }} </small>
            </i>
          </strong>
        </div>
      </section>
    </div>

    <div
      class="d-flex flex-column justify-content-center gap-2 gap-md-0 col-12 col-lg-9 col-xl-8"
      [ngClass]="{ 'opacity-50': !userData.enabled }"
    >
      <div class="row w-100 w-md-32 d-flex">
        <span class="font-bold fs-5 m-0 p-0">
          {{ userData.content.name | trimString }}
        </span>
        <div class="content-header">
          <span class="content-badge " [ngClass]="{'active': userData.enabled}">
            {{ userData.enabled ? ('shared-components.list-element.enabled' | translate) : ('shared-components.list-element.disabled' | translate) }}
          </span>
        </div>
      </div>
      <div *ngIf="!isSingleRowDesign" class="row mt-1">
        <span class="m-0 p-0">
          <small class="responsive-text">
            {{
              userData.content.description
                ? (userData.content.description | trimString : 125)
                : "N/A"
            }}
          </small>
        </span>
      </div>
    </div>

    <div
      class="d-flex flex-column align-items-lg-center justify-content-center col-12 col-lg-2 col-xl-3 mt-3 m-md-0 p-0"
    >
      <div class="d-flex align-items-center justify-content-lg-end gap-3">
        <ng-container *ngFor="let action of actions">
          <!-- Toggle switch for toggle_enabled action -->
          <div *ngIf="action.action === 'toggle_enabled'" class="toggle-switch-container">
            <label class="toggle-switch" [title]="action.title">
              <input
                type="checkbox"
                [checked]="userData.enabled"
                (change)="_onClickAction($event, action.action)"
              />
              <span class="toggle-slider"></span>
            </label>
          </div>

          <!-- Action buttons with SVG icons -->
          <button
            *ngIf="action.action !== 'toggle_enabled'"
            class="action-btn"
            [ngClass]="{
              'btn-view_content': action.action === 'view_content',
              'btn-view_teaching_guide': action.action === 'view_teaching_guide',
            }"
            [attr.data-tooltip]="action.title || action.action"
            (click)="_onClickAction($event, action.action)"
          >
            <!-- Icono de ver contenido -->
            <svg *ngIf="action.action === 'view_content'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
            </svg>
            <!-- Icono view_teaching_guide  -->
            <svg *ngIf="action.action === 'view_teaching_guide'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
            </svg>

          </button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultTemplateOrganizations let-groupData>
  <div
    class="row gap-2 gap-lg-0 ps-3 ps-lg-0"
    [class.ps-lg-3]="isCheckable || isDragable"
  >
    <div
      class="d-flex align-items-md-center justify-content-start col-12 col-xxl-1 m-0 p-0 text-italic"
      [class.col-lg-1]="!isDragable && !isCheckable"
      [class.col-lg-2]="isDragable && isCheckable"
      [class.justify-content-center]="!isDragable && !isCheckable"
    >
      <section
        class="d-flex flex-nowrap row-md w-100 gap-2"
        [class.gap-4]="isDragable && isCheckable"
      >
        <div
          class="d-flex"
          [class.col-12]="!isDragable && !isCheckable"
          [class.col-10]="isDragable || isCheckable"
          [class.justify-content-lg-center]="!isDragable || !isCheckable"
        >
          <img
            *ngIf="!groupData.logo"
            src="/assets/images/icons/icon_team_green.svg"
            alt="Team avatar"
            class="rounded-circle"
            style="max-width: 60px"
          />

          <img
            *ngIf="groupData.logo"
            [src]="groupData.logo"
            alt="Team avatar"
            class="rounded-circle"
            style="width: 60px; height: 60px; object-fit: cover"
          />
        </div>
      </section>
    </div>

    <div
      class="d-flex flex-column justify-content-center gap-2 gap-md-0 col-12 col-lg-9 col-xl-8"
    >
      <div class="row w-100 w-md-32">
        <span class="font-bold fs-5 m-0 p-0">{{
          groupData["name"] | trimString
        }}</span>
      </div>

      <div *ngIf="!isSingleRowDesign" class="row">
        <div class="d-flex align-items-center p-0 m-0 col-12 col-lg-8">
          <div
            class="d-flex align-items-center justify-content-center p-0 m-0 mx-2"
          ></div>
        </div>
      </div>
    </div>

    <section class="colors">
      <div
        [style.background]="
          'linear-gradient(-250deg, rgba(217, 217, 217, 0) 19.19%, ' +
          groupData.primary_color +
          ' 53.96%, ' +
          groupData.secondary_color +
          ' 84.87%)'
        "
      ></div>
    </section>
  </div>
  <div class="class-stats">
     <span class="stat-badge progress" [ngClass]="{'high' : groupData['average_progress'] === 100}">
              <svg class="stat-icon" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"></path>
              </svg>
         {{ groupData["average_progress"] | customPercentage }}
         {{ "shared-components.list-element.average-progress" | translate }}
      </span>
  </div>
</ng-template>
